/**
 * Data fields in the form to include in form when updated outside of form
 * context.
 */
// importUpdates changes
// const dataFieldsToUpdate = ['status', 'enrichmentStatus', 'upToDate'];
const dataFieldsToUpdate = [
  'status',
  'enrichmentStatus',
  'updateNotificationList'
];

/**
 * Merges data originating from outside of form context into the form, e.g.
 * when the object changes state due to lifecycle actions.
 * @param props
 * @param state
 * @returns {*} The new state if there is any data to include, otherwise null
 */
function mergeUpdatedData(props, state) {
  let updated = false;

  const mergedState = dataFieldsToUpdate.reduce(
    (newState, dataFieldToUpdate) => {
      const oldValue =
        dataFieldToUpdate === 'updateNotificationList'
          ? state.data[dataFieldToUpdate] !== undefined
            ? state.data[dataFieldToUpdate].length
            : 0
          : state.data[dataFieldToUpdate];
      // const newValue = props.data[dataFieldToUpdate];
      const newValue =
        dataFieldToUpdate === 'updateNotificationList'
          ? props.data[dataFieldToUpdate] !== undefined
            ? props.data[dataFieldToUpdate].length
            : 0
          : props.data[dataFieldToUpdate];
      // console.log(oldValue,newValue)

      const newFieldVlaue =
        dataFieldToUpdate === 'updateNotificationList' && newValue === 0
          ? []
          : props.data[dataFieldToUpdate];

      if (oldValue !== newValue) {
        updated = true;
        return {
          ...newState,
          data: {
            ...newState.data,
            [dataFieldToUpdate]: newFieldVlaue
          }
        };
      }
      return newState;
    },
    props
    // importUpdates changes states
  );

  return updated ? mergedState : null;
}

// eslint-disable-next-line import/prefer-default-export
export { mergeUpdatedData };
